var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "hostess-rank-base",
      class: { kiko: _vm.packageName === "kiko" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: _vm.$t("lang.commonM.k240"), "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "tit-right",
                        on: { click: _vm.handleToRule },
                      },
                      [
                        _c("img", {
                          staticClass: "left-nav",
                          attrs: { src: require("./images/h-q.png"), alt: "" },
                        }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "hostess-rank-bar",
          style: { "margin-top": `-${_vm.barHeight + 46}px` },
        },
        [
          _vm.packageName !== "kiko"
            ? _c("img", {
                staticClass: "base-bg",
                attrs: { src: require("./images/h-head.png") },
              })
            : _vm._e(),
          _vm.packageName === "kiko"
            ? _c("img", {
                staticClass: "base-bg",
                attrs: { src: require("./images/h-head-kiko.png") },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "rank-head" },
            [
              _c(
                "div",
                { staticClass: "rank-reward" },
                [
                  _c("img", {
                    staticClass: "reward-cup",
                    attrs: { src: require("./images/h-winicon.png") },
                  }),
                  _c("MyPLabel", {
                    attrs: {
                      str: _vm.$t("lang.commonM.k166"),
                      numsOption: [
                        { value: _vm.thousandthDigit(_vm.totalReward) },
                      ],
                    },
                  }),
                  _c("img", {
                    staticClass: "reward-bean",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ],
                1
              ),
              _c("MyPLabel", {
                staticClass: "rank-time",
                attrs: {
                  str: _vm.$t("lang.commonM.k167"),
                  numsOption: [{ value: _vm.limitTime }],
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "prize" }, [
            _c("div", { staticClass: "two" }, [
              _c("div", { staticClass: "rank_c2_avatar" }, [
                _vm.prize2.avatar
                  ? _c("img", {
                      attrs: {
                        src: _vm._f("imgPath")(_vm.prize2.avatar),
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._m(0),
              _c("div", { staticClass: "item-num" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.prize2.nickname)),
                ]),
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.prize2.score)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "one" }, [
              _c("div", { staticClass: "rank_c1_avatar" }, [
                _vm.prize1.avatar
                  ? _c("img", {
                      attrs: {
                        src: _vm._f("imgPath")(_vm.prize1.avatar),
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._m(1),
              _c("div", { staticClass: "item-num" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.prize1.nickname)),
                ]),
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.prize1.score)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "three" }, [
              _c("div", { staticClass: "rank_c3_avatar" }, [
                _vm.prize3.avatar
                  ? _c("img", {
                      attrs: {
                        src: _vm._f("imgPath")(_vm.prize3.avatar),
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._m(2),
              _c("div", { staticClass: "item-num kiss-num3" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.prize3.nickname)),
                ]),
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.prize3.score)),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "hostess-rank-con" }, [
        _c(
          "div",
          { staticClass: "rank-body" },
          [
            _c("div", { staticClass: "date-limit" }, [
              _c("div", { staticClass: "date-select" }, [
                _c(
                  "div",
                  { staticClass: "btn", on: { click: _vm.handleSelecWeek } },
                  [
                    _vm._v(" " + _vm._s(_vm.chooseWeek) + " "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow03.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
                _vm.showWeek
                  ? _c("div", { staticClass: "select" }, [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.selectWeek(0, _vm.week0)
                            },
                          },
                        },
                        [_vm._v(_vm._s(this.week0))]
                      ),
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.selectWeek(-1, _vm.week1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(this.week1))]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k168"))),
              ]),
            ]),
            _vm.rankList && _vm.rankList.length > 0
              ? _vm._l(_vm.rankList, function (item) {
                  return _c("div", { key: item, staticClass: "agent-item" }, [
                    item.rank
                      ? _c("span", { staticClass: "rank-num" }, [
                          _vm._v(_vm._s(item.rank)),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "avatar rank-avatar" }, [
                      item.avatar
                        ? _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(item.avatar),
                              alt: "",
                            },
                          })
                        : _vm._e(),
                      _c("span", [_vm._v(_vm._s(item.nickname))]),
                    ]),
                    _c("div", { staticClass: "item-num" }, [
                      _vm._v(" " + _vm._s(item.score) + " "),
                    ]),
                  ])
                })
              : _c("div", { staticClass: "rank-nodata" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k169")) + " "),
                ]),
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass: "agent-item owner-item",
            style: { "margin-bottom": `${_vm.bottomBarHeight}px` },
          },
          [
            _c("div", { staticClass: "owner-item-content" }, [
              _c("div", { staticClass: "avatar" }, [
                _vm.owners.rank && _vm.owners.rank > 0
                  ? _c("span", { staticClass: "rank-num" }, [
                      _vm._v(_vm._s(_vm.owners.rank)),
                    ])
                  : _c("span", { staticClass: "rank-num" }, [_vm._v("--")]),
                _c("div", { staticClass: "avatar-box" }, [
                  _vm.owners.avatar
                    ? _c("img", {
                        attrs: {
                          src: _vm._f("imgPath")(_vm.owners.avatar),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _c("div", [
                    _c("span", { staticClass: "owner-nickname" }, [
                      _vm._v(_vm._s(_vm.owners.nickname)),
                    ]),
                    !_vm.owners.rank || !(_vm.owners.rank > 0)
                      ? _c("span", { staticClass: "owner-rank" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k169"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "item-num" }, [
                _vm._v(" " + _vm._s(_vm.owners.score || 0) + " "),
              ]),
            ]),
          ]
        ),
      ]),
      _vm.rankDiaShow
        ? _c("div", { staticClass: "rank-mask" }, [
            _c(
              "div",
              { staticClass: "rank-dia" },
              [
                _c("div", { staticClass: "rank-dia-avatar" }, [
                  _vm.owners.avatar
                    ? _c("img", {
                        attrs: {
                          src: _vm._f("imgPath")(_vm.owners.avatar),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "rank-dia-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k170"))),
                ]),
                _vm.configData.userRankRewardDTO.reward
                  ? _c("MyPLabel", {
                      staticClass: "rank-dia-tips",
                      attrs: {
                        numsOption: [
                          {
                            value: `${_vm.configData.userRankRewardDTO.reward}`,
                            style:
                              _vm.packageName !== "kiko"
                                ? "color:#a338fc"
                                : "color:#b79b21",
                          },
                        ],
                        str: _vm.$t("lang.commonM.k171"),
                      },
                    })
                  : _c("div", { staticClass: "rank-dia-tips" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k171_1"))),
                    ]),
                _c("div", { staticClass: "rank-dia-con" }, [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k168")))]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.configData.userRankRewardDTO.calls)),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("lang.kissGf.ranking")))]),
                    _vm.configData.userRankRewardDTO.rank > 0
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.configData.userRankRewardDTO.rank)),
                        ])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k169"))),
                        ]),
                  ]),
                ]),
                _c("MyPLabel", {
                  staticClass: "rank-dia-txt",
                  attrs: {
                    str: _vm.$t("lang.commonM.k173"),
                    numsOption: [{ value: _vm.limitTime }],
                  },
                }),
                _vm.configData.userRankRewardDTO.reward
                  ? [
                      _vm.configData.userRankRewardDTO.rewardState == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "rank-dia-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.handleSure("claim")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                          )
                        : _vm._e(),
                    ]
                  : _c(
                      "div",
                      {
                        staticClass: "rank-dia-btn",
                        on: {
                          click: function ($event) {
                            return _vm.handleSure("ok")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                    ),
                _c("div", {
                  style: {
                    height: `${
                      _vm.bottomBarHeight ? _vm.bottomBarHeight + 25 : 25
                    }px`,
                  },
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm.rankRulesDiaShow
        ? _c("div", { staticClass: "rank-mask" }, [
            _c("div", { staticClass: "rank-dia rules-dia" }, [
              _c("div", { staticClass: "rank-dia-tit" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k170"))),
              ]),
              _c("div", { staticClass: "rank-dia-tips" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k258"))),
              ]),
              _c(
                "div",
                { staticClass: "rank-dia-con" },
                [
                  _c("div", { staticClass: "list-fields right-read" }, [
                    _c("div", { staticClass: "field field1" }, [
                      _vm._v(_vm._s(_vm.$t("lang.kissGf.ranking"))),
                    ]),
                    _c("div", { staticClass: "field field2" }, [
                      _vm._v(" " + _vm._s(_vm.$t("lang.mybean.bonus")) + " "),
                      _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                    ]),
                  ]),
                  _c("div", {
                    staticStyle: {
                      width: "100%",
                      height: "1px",
                      "background-color": "rgba(255, 255, 255, 0.2)",
                    },
                  }),
                  _vm._l(_vm.configData.rankRewardDTOs, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "list-fields right-read" },
                      [
                        index === 0
                          ? _c("div", { staticClass: "bd-field field1" }, [
                              _c("img", {
                                attrs: { src: require("./images/lv1.png") },
                              }),
                            ])
                          : index === 1
                          ? _c("div", { staticClass: "bd-field field1" }, [
                              _c("img", {
                                attrs: { src: require("./images/lv2.png") },
                              }),
                            ])
                          : index === 2
                          ? _c("div", { staticClass: "bd-field field1" }, [
                              _c("img", {
                                attrs: { src: require("./images/lv3.png") },
                              }),
                            ])
                          : _c("div", { staticClass: "bd-field field1" }, [
                              _vm._v(_vm._s(item.range)),
                            ]),
                        _c("div", { staticClass: "bd-field field2" }, [
                          _vm._v(_vm._s(item.rewardCount)),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "rank-dia-btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleToRule(true)
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("lang.instantPayment.dialogButtonText1"))
                  ),
                ]
              ),
              _c("div", {
                style: {
                  height: `${
                    _vm.bottomBarHeight ? _vm.bottomBarHeight + 25 : 25
                  }px`,
                },
              }),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-sort" }, [
      _c("img", { attrs: { src: require("./images/h-second.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-sort" }, [
      _c("img", { attrs: { src: require("./images/h-first.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-sort" }, [
      _c("img", { attrs: { src: require("./images/h-third.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }